export default __webpack_public_path__ + "static/media/analytics-active.b76393a2.svg";